import React, {useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import {FormDialog }from "../../../../controls";
import { MovementTimes } from "../../../Trips/components/TripListDialogs/MovementsTooltip";
import FinanceTripLegList from '../FinanceTripLegList';

const FinanceTripLegsDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const queryClient = useQueryClient();
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    tripUuid: null,
    title: 'Trip Sectors',
  });

  const DisplayForm = () => {
    return (
      <FormDialog
        title={dialogState.title}
        message=""
        open={dialogState.showDialog}
        record={{}}
        dialogOptions={{maxWidth: "1600", fullWidth: false}}
        classes={classes}
        buttons = {{
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
          } else {
            setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
            if (typeof props.onClose === 'function') {props.onClose()}
          }
        }}
      >
        <div style={{display: "inline-block", width: 1600}} checkChildren={true}>
          <FinanceTripLegList tripUuid={dialogState.tripUuid} canEdit={dialogState.canEdit} />
        </div>
      </FormDialog>
    )
  }

  useEffect(()=> {
    const open = async (params) => {
      //TODO: tripLegUuid should be primaryObjectUuid as it can be either tripLegUuid or tripUuid
      const {canEdit, tripUuid} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, tripUuid});
    }
    eventBus.bind("FinanceTripLegsDialog.open", open);
    return () => {
      eventBus.unbind("FinanceTripLegsDialog.open", open);
      queryClient.invalidateQueries("TripLegs");
    }
  }, [dialogState, eventBus, queryClient]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default FinanceTripLegsDialog;
